import { render } from "./BackBarTutorialAnimation2.vue?vue&type=template&id=70312fe3&scoped=true&ts=true"
import script from "./BackBarTutorialAnimation2.vue?vue&type=script&lang=ts"
export * from "./BackBarTutorialAnimation2.vue?vue&type=script&lang=ts"

import "./BackBarTutorialAnimation2.vue?vue&type=style&index=0&id=70312fe3&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70312fe3"]])

export default __exports__